import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=79b17bb1&scoped=true"
import script from "./Main.ts?vue&type=script&lang=ts&external"
export * from "./Main.ts?vue&type=script&lang=ts&external"
import style0 from "./Main.vue?vue&type=style&index=0&id=79b17bb1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b17bb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b17bb1')) {
      api.createRecord('79b17bb1', component.options)
    } else {
      api.reload('79b17bb1', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=79b17bb1&scoped=true", function () {
      api.rerender('79b17bb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/S3Connector/pages/Main/Main.vue"
export default component.exports